import initCustomScrollbar from "../modules/init-custom-scrollbar.js";

const initBlock = async function( block ) {
	const testimonialsSlider = block.find( ".js-testimonials-slider" );

	if ( testimonialsSlider.length ) {
		const { Swiper } = await import( "swiper" );
		const { Navigation, EffectFade } = await import( "swiper/modules" );
		await import( "../scrollbar.min.js" );
		await import( "swiper/css" );
		await import( "swiper/css/effect-fade" );

		new Swiper( testimonialsSlider[0], {
			modules: [Navigation, EffectFade],
			slidesPerView: 1,
			allowTouchMove: false,
			effect: "fade",
			loop: true,
			fadeEffect: {
				crossFade: true,
			},
			navigation: {
				prevEl: block.find( "[data-prev-el]" )[0],
				nextEl: block.find( "[data-next-el]" )[0],
			},
		} );

		initCustomScrollbar( block );
	}

};

themeUtils.loadBlock( initBlock, "testimonials", ".section-testimonials" );
themeUtils.loadBlock( initBlock, "testimonials", ".section-testimonials-alt" );
